var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-input',_vm._g(_vm._b({ref:"pInput",attrs:{"icon":_vm.currentIcon,"type":_vm.showPassword ? 'text': 'password'},on:{"handle-icon-click":function($event){_vm.showPassword = !_vm.showPassword}}},'p-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }